<template>
  <div v-if="data">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-swipe v-if="data.resUrl" ref="TopSwipe" class="topad" :autoplay="6000" @change="onTopSwipe">
      <van-swipe-item v-for="(image, index) in data.resUrl" :key="index">
        <img :src="image" style="width:100%">
      </van-swipe-item>
      <div slot="indicator" class="custom-indicator swipeTop" style="background-color:transparent;color:#000;">
        <span v-for="(image, index) in data.resUrl" :key="index">
          <a v-if="NowTopSwipe == index" class="mainColor"><i class="iconfont iconline" /></a>
          <a v-if="NowTopSwipe != index"><i class="iconfont iconline" /></a>
        </span>
      </div>
    </van-swipe>
    <div class="rect">

      <div class="info">
        <span class="pageTitle1">{{ data.title }}</span>
        <br><br>
        <span class="price">￥{{ data.lowPrice }}</span><span class="pagebody2 aboutStr">月售{{ data.sellNum }} | 评价{{ data.commentNum }}</span>

      </div>
    </div>
    <div class="rectTable">
      <van-tabs v-if="data" title-active-color="#E32119" animated>
        <van-tab v-if="data.IndependentTitle !=null && data.IndependentTitle.length>0" class="tab" :title="data.IndependentTitle" v-html="data.IndependentBody" />
        <van-tab class="tab" :title="data.commodityTitle">
          <div class="commodityBody" v-html="data.commodityBody" />
        </van-tab>
        <van-tab class="tab" title="中心介绍" v-html="data.shopBody" />
        <van-tab class="tab" title="评价">
          <van-list
            v-model="loadingComment"
            :finished="finishedComment"
            finished-text="没有更多了"
            @load="onLoadComment"
          >
            <div v-for="item in listComment" :key="item.commentId" class="comment">
              <van-row>
                <van-col span="3">
                  <van-image
                    width="3em"
                    height="3em"
                    fit="cover"
                    :src="item.userIcon"
                  />
                </van-col>
                <van-col span="1" />
                <van-col span="18">
                  <span class="pageTitle1">{{ item.userName }}</span><br>
                  <span class="pagebody3 aboutStr">{{ formatDate(item.createTime,"yyyy-MM-dd") }} {{ item.specificaionName }}</span>
                  <div class="body pagebody1">{{ item.body }}</div>
                  <van-image
                    v-for="(img, index) in item.res"
                    :key="img"
                    class="photo"
                    :src="img"
                    fit="cover"
                    @click="PreviewUserImage(item.res,index)"
                  />
                </van-col>
              </van-row>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
      <div class="downHideLine" />
    </div>
    <van-goods-action>
      <van-goods-action-icon
        icon-class="iconfont iconkefu"
        text="客服"
        @click="onClickService"
      />
      <!-- <van-goods-action-icon
        icon="cart-o"
        text="购物车"
        @click="onClickCar"
      /> -->
      <van-goods-action-button
        type="danger"
        text="立即预定"
        style="height:50px;"
        :loading="BookNowLoading"
        @click="onClickBookButton"
      />
    </van-goods-action>
    <van-popup v-model="showDateSelect" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :max-date="maxDate"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="onDateConfirm"
        @cancel="onDateCancel"
      />
    </van-popup>

    <van-popup v-model="showSKU" position="buttom">
      <img src="https://my.divessi.com/data/Image/facility_logos/786016.png" class="viewPic">
      <div class="close"><i class="iconfont iconquit" /></div>
      <div class="titleRect">
        <div class="title pagebody1">{{ data.title }}</div>
        <div v-if="price != basePrice" class="price"><span class="true">￥{{ price }}</span><span class="base">￥<del>{{ basePrice }}</del></span></div>
        <div v-if="price == basePrice" class="price"><span class="true">￥{{ price }}</span></div>
      </div>
      <div class="model">
        <div v-if="data && data.specification && data.specification.MAIN" class="pagebody1">套餐类型
          <buttonSelect v-model="SpecificationMAIN" :typelist="data.specification.MAIN" />
        </div>
        <!-- <div v-if="data && data.specification && data.specification.HOTEL" class="pagebody1">住宿
          <buttonSelect v-model="SpecificationHOTEL" :typelist="data.specification.HOTEL" />
        </div>
        <div v-if="data && data.specification && data.specification.TRAFFIC" class="pagebody1">交通
          <buttonSelect v-model="SpecificationTRAFFIC" :typelist="data.specification.TRAFFIC" />
        </div>
        <div v-if="data && data.specification && data.specification.OTHER" class="pagebody1">其他
          <buttonSelect v-model="SpecificationOTHER" :typelist="data.specification.OTHER" />
        </div> -->
      </div>
      <div class="num">
        <van-row>
          <van-col span="10">
            <div class="pagebody1">购买数量</div>
            <!-- <span class="aboutStr pagebody1">剩余998件</span> -->
          </van-col>
          <van-col span="12" style="text-align:right">
            <van-stepper
              v-model="order.num"
              integer
              :min="1"
              :max="10"
            />
          </van-col>
        </van-row>
      </div>
      <div class="input pagebody1">
        <van-row>
          <van-col span="6">
            开课日期
          </van-col>
          <van-col span="18">
            <input v-model="order.bookStartTime" type="text" placeholder="请选择开课日期" readonly @click="showDatePickup">
          </van-col>
        </van-row>
      </div>
      <div class="input pagebody1">
        <van-row>
          <van-col span="6">
            联系人
          </van-col>
          <van-col span="18">
            <input v-model="order.bookMan" type="text" placeholder="请输入联系人称呼">
          </van-col>
        </van-row>
      </div>
      <div class="input pagebody1">
        <van-row>
          <van-col span="6">
            联系手机号
          </van-col>
          <van-col span="18">
            <input v-model="order.bookContact" type="text" placeholder="请输入联系人手机号">
          </van-col>
        </van-row>
      </div>
      <div class="buttons">
        <!-- <van-button type="warning" size="large" square>加入购物车</van-button> -->
        <van-button type="info" size="large" :loading="BookNowLoading" square loading-text="下单中..." @click="onBookNow">立即预定</van-button>
      </div>
    </van-popup>
    <Dialogue v-model="showDialogue" :commodity-id="data.id" :shop-id="data.shopId" />
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import Dialogue from '@/components/Dialogue'
import buttonSelect from '@/components/buttonSelect'
import { formatDate, initPage, getUrlKey, MyNotify } from '@/utils/base'
import { DatetimePicker, Field, Stepper, Button, Popup, Tab, Tabs, Swipe, SwipeItem, Image, ImagePreview, GoodsAction, GoodsActionIcon, GoodsActionButton, List } from 'vant'
export default {
  components: {
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [Stepper.name]: Stepper,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [List.name]: List,
    TopBar,
    Dialogue,
    buttonSelect
  },
  data() {
    return {
      title: '产品详情',
      backurl: '/store/index',
      NowTopSwipe: 0,
      showSKU: false,
      showDateSelect: false,
      minDate: new Date(),
      maxDate: undefined,
      currentDate: new Date(),
      SpecificationMAIN: undefined,
      SpecificationHOTEL: undefined,
      SpecificationTRAFFIC: undefined,
      SpecificationOTHER: undefined,
      data: undefined,
      price: 0,
      basePrice: 0,
      BookNowLoading: false,
      showDialogue: false,
      listComment: [],
      loadingComment: false,
      finishedComment: false,
      searchComment: {
        commodityId: undefined,
        limit: 30,
        page: 1
      },
      order: {
        commodityId: undefined,
        specificationId: [],
        num: 1,
        bookStartTime: undefined,
        bookMan: undefined,
        bookContact: undefined
      }
    }
  },
  watch: {
    SpecificationMAIN(newValue, oldValue) {
      console.log('SpecificationMAIN', newValue)
      if (newValue === undefined) {
        this.price = this.data.lowPrice
        this.basePrice = this.data.lowPrice
        // this.order.specificationId = this.order.specificationId.filter((item, index, array) => {
        //   return item === newValue.value
        // })
        this.order.specificationId = []
      } else {
        this.price = newValue.price
        this.basePrice = newValue.basePrice
        this.order.specificationId = [newValue.value]
        // this.order.specificationId.push(newValue.value)
      }
    }
  },
  activated() {
    this.minDate = new Date()
    this.maxDate = new Date()
    this.maxDate.setYear(this.maxDate.getFullYear() + 1)
  },
  created() {
    this.maxDate = new Date()
    this.maxDate.setYear(this.maxDate.getFullYear() + 1)
    initPage(false)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.id = this.$route.params.id
    this.title = '产品'
    this.order.commodityId = this.id
    this.searchComment.commodityId = this.id
    request({
      url: '/Store/getShopCommodity',
      method: 'post',
      params: { id: this.id }
    }).then(response => {
      if (!response.success) {
        this.error = true
        return
      }
      console.log('response', response)
      this.data = response.data
      this.price = this.data.lowPrice
      this.basePrice = this.data.lowPrice

      this.title = this.data.title
    })
  },
  methods: {
    PreviewUserImage(list, index) {
      ImagePreview({
        images: list,
        startPosition: index,
        minZoom: 1
      })
    },
    onTopSwipe(index) {
      this.NowTopSwipe = index
    },
    gotoTopSwipe(index) {
      this.NowTopSwipe = index
      this.$refs.TopSwipe.swipeTo(index)
    },
    onClickService() {
      this.showDialogue = !this.showDialogue
    },
    onClickCar() {
      // 暂不支持
    },
    onClickBookButton() {
      this.BookNowLoading = true
      request({
        url: '/Store/tryCreateOrderCourse',
        method: 'post'
      }).then(response => {
        this.BookNowLoading = false
        if (!response.success) {
          this.error = true
          return
        }
        this.showSKU = true
      })
    },
    showDatePickup() {
      this.showDateSelect = true
    },
    formatDate,
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    onDateConfirm() {
      this.order.bookStartTime = formatDate(this.currentDate, 'yyyy-MM-dd')
      this.showDateSelect = false
    },
    onDateCancel() {
      this.showDateSelect = false
      this.order.bookStartTime = undefined
    },
    changeType(list, value) {
      console.log('typeHouse', this.typeHouse)
      this.typeList.push({ text: '测试', value: '10' })
      list.forEach(item => {
        if (item.value === value) {
          if (item.select) {
            item.select = undefined
          } else {
            item.select = true
          }
        } else {
          item.select = undefined
        }
      })
      // this.typeOne = JSON.parse(JSON.stringify(list))
    },
    onLoadComment() {
      console.log('加载了onLoadComment')
      this.loadingComment = true
      request({
        url: '/Store/getCommentList',
        method: 'post',
        data: this.searchComment
      }).then(response => {
        if (!response.success) {
          return
        }
        this.loadingComment = false
        this.searchComment.limit = response.data.limit
        this.searchComment.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.listComment.push(item)
        })
        if (response.data.rows.length < this.searchComment.limit) {
          this.finishedComment = true
        }
      })
    },
    onBookNow() {
      if (this.order.specificationId.length <= 0) {
        MyNotify('info', '请选择套餐')
        return
      }
      if (this.order.bookStartTime === undefined || this.order.bookStartTime.length <= 0) {
        MyNotify('info', '请选择开课日期')
        return
      }
      if (this.order.bookMan.trim().length <= 0) {
        MyNotify('info', '请填写联系人')
        return
      }
      if (this.order.bookContact.trim().length !== 11) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      var reg = /^1\d{10}$/
      if (!reg.test(this.order.bookContact.trim())) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      this.BookNowLoading = true
      request({
        url: '/Store/CreateOrderCourse',
        method: 'post',
        data: this.order
      }).then(response => {
        this.BookNowLoading = false
        if (!response.success) {
          this.error = true
          return
        }
        this.$router.replace('/store/orderInfo/' + response.data)
      })
    }
  }
}
</script>
<style scoped>
.rect{
  padding:1em;
  background-color: #F1F1F1;
}
.swipeTop{
  background-color:transparent;
}
.rect .price{
    color:#E32119;
    font-weight: 700;
    margin-right: 1.5em;
}

.rectTable .tab{
 background-color: #fff;
  padding: 0 1em;
}

.comment{
    border-bottom: 1px solid #dadada;
    margin: 1em 0;
    padding-bottom: 1em;
}
.comment .head{
    width: 100%;
}
.comment .body{
    margin-top: 0.8em;
}
.comment .photo{
    width: 3em;
    height: 3em;
    margin: 0.25em 0.25em 0 0;
}
.downHideLine{
  height: 50px;
}

.van-popup{
  width: 100%;
  bottom: 0;
  overflow: visible;
}
.van-popup .viewPic{
  width: 6em;
  height: 6em;
  position: absolute;
  left:1em;
  top:-1em;
  border-radius: 0.2em;
}

.van-popup .titleRect{
  height: 5em;
  margin-left: 7em;
  padding: 0.5em;
}
.van-popup .titleRect .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-right: 3em;
}
.van-popup .titleRect .price{

  margin-top: 0.8em;
}
.van-popup .titleRect .price .true{
  color:#E32119;
  font-weight: 700;
  font-size: 1.1em;
}
.van-popup .titleRect .price .base{
  color:#999;
  margin-left: 1em;
  font-size: 0.8em;
}
.van-popup .close{
  position: absolute;
  right: 0.5em;
  top:0.5em;
}
.van-popup .model{
  border-top: 1px solid #eaeaea;
  margin: 0 1em;
  padding: 0.5em 0;
}
.van-popup .model button{
  margin: 0.25em 0.5em 0.25em 0;
}

.van-popup .num{
  border-top: 1px solid #eaeaea;
  margin: 0 1em;
  padding: 0.5em 0;
}

.van-popup .input{
  border-top: 1px solid #eaeaea;
  padding: 0.7em 0;
  margin: 0 1em;
}
.van-popup .input input{
  width:100%;
  border:0;
}

.van-popup .buttons{
  padding-top: 1em;
}
.van-popup .buttons button{
  width: 100%;
  height: 3em;
}
</style>
<style>
.commodityBody img{
  max-width:100%;
}
</style>
